import { render, staticRenderFns } from "./EncounterbyDiagnosis.vue?vue&type=template&id=32008ca4&"
import script from "./EncounterbyDiagnosis.vue?vue&type=script&lang=js&"
export * from "./EncounterbyDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./EncounterbyDiagnosis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports